import durationService from "app/services/DurationService";

import type { MonitorAndProtectTrademarkParams } from "../../../app/trademark/routes.types";
import type { RedirectHandler } from "../types";

const DEFAULT_DURATION = "28d";
const MAX_SUPPORTED_DAYS = 28;

function isValidDurationForNonAdsPages(duration: string | undefined): boolean {
    if (!duration || duration === DEFAULT_DURATION) {
        return true;
    }

    // Handle preset formats like "7d", "14d", etc.
    const dayPresetMatch = duration.match(/^(\d+)d$/);
    if (dayPresetMatch) {
        const days = parseInt(dayPresetMatch[1], 10);
        return days <= MAX_SUPPORTED_DAYS;
    }

    try {
        // Let DurationService parse the duration
        const durationData = durationService.getDurationData(duration);
        const fromDate = durationData.raw.from;
        const toDate = durationData.raw.to;

        // Calculate the number of days in the duration
        const durationDays = toDate.diff(fromDate, "day") + 1; // +1 to include both from and to dates

        // Duration must not exceed MAX_SUPPORTED_DAYS
        return durationDays <= MAX_SUPPORTED_DAYS;
    } catch {
        // If DurationService can't parse it, it's not valid
        return false;
    }
}

export const durationResetHandler: RedirectHandler = (transition) => {
    const currentParams = transition.params() as MonitorAndProtectTrademarkParams;

    const currentDuration = currentParams.duration as string | undefined;

    if (!isValidDurationForNonAdsPages(currentDuration)) {
        return {
            params: {
                ...currentParams,
                duration: DEFAULT_DURATION,
            },
        };
    }

    return void 0;
};
